import { useEffect, useState } from 'react'

export function useStoredState<T>(
  key: string,
  createDefault: () => T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = window.localStorage.getItem(key)
      return stored ? (JSON.parse(stored) as T) : createDefault()
    } catch {
      return createDefault()
    }
  })

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // Storage may be unavailable in private or restricted browsing contexts.
    }
  }, [key, value])

  return [value, setValue]
}

